import { getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY?.trim() ?? "",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN?.trim() ?? "",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID?.trim() ?? "",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET?.trim() ?? "",
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID?.trim() ?? "",
  appId: import.meta.env.VITE_FIREBASE_APP_ID?.trim() ?? "",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID?.trim() ?? "",
};

export const hasFirebaseConfig = [
  firebaseConfig.apiKey,
  firebaseConfig.authDomain,
  firebaseConfig.projectId,
  firebaseConfig.storageBucket,
  firebaseConfig.messagingSenderId,
  firebaseConfig.appId,
].every(Boolean);

export const appPublicUrl =
  import.meta.env.VITE_APP_PUBLIC_URL?.trim() || window.location.origin;

const app = hasFirebaseConfig
  ? getApps()[0] ?? initializeApp(firebaseConfig)
  : undefined;

export const auth = app ? getAuth(app) : undefined;
export const firestore = app ? getFirestore(app) : undefined;
export const functions = app
  ? getFunctions(
      app,
      import.meta.env.VITE_FIREBASE_FUNCTIONS_REGION?.trim() || "europe-west1",
    )
  : undefined;

export const USERS_COLLECTION = "users";
export const ADMIN_INVITATIONS_COLLECTION = "adminInvitations";
export const AUDIT_EVENTS_COLLECTION = "auditEvents";
export const FORMATIONS_COLLECTION = "formations";
export const SESSIONS_COLLECTION = "sessions";
